<div class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">  
        <form [formGroup]="formGroup" novalidate>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" 
                [dividerColor]="appService.isNegative(parent.order.P_TotalAmount)">
                    <input matInput type="number" placeholder="{{translations.txtTotalAmount}}"  
                    formControlName="P_TotalAmount" [(ngModel)]="parent.order.P_TotalAmount" required
                    
                    (keypress)="appService.onlyPositiveNumber($event)"  min="0" max="99999.99"
                    (change)="updateOutstanding($event)"
                   >
                    <mat-error *ngIf="formGroupErrors.P_TotalAmount.required">
                        {{translations.msgPleaseEnterTotalA}}
                    </mat-error>
                   
                <mat-error *ngIf="formGroupErrors.P_TotalAmount.min">{{translations.msgInvalidTotalAmount}}</mat-error>	
                <mat-error *ngIf="formGroupErrors.P_TotalAmount.max">{{translations.msgInvalidTotalAmount}}</mat-error>
                <mat-error *ngIf="formGroupErrors.P_TotalAmount.pattern">
                    {{translations.msg2Decimal}}
                </mat-error>
                </mat-form-field>
    
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" [dividerColor]="appService.isNegative(parent.order.P_DepositeAmount)">
                    <input matInput  type="number" placeholder="{{translations.txtDepositeAmount}}" 
                    formControlName="P_DepositeAmount"  (change)="updateOutstanding($event)"
                    [(ngModel)]="parent.order.P_DepositeAmount" 
                    required min="0" max="99999.99" 
                    
                    (keypress)="appService.onlyPositiveNumber($event)" [style.color]="parent.order.P_DepositeAmount!= undefined ? (parent.order.P_DepositeAmount.toString().indexOf('-') > -1 ? 'red' : '') : ''">
                    <mat-error *ngIf="formGroupErrors.P_DepositeAmount.required">
                        {{translations.msgPleaseEnterDeposite}}
                    </mat-error>
                   
                    <mat-error *ngIf="formGroupErrors.P_DepositeAmount.min">{{translations.msgInvalidDepositeAmount}}</mat-error>	
                    <mat-error *ngIf="formGroupErrors.P_DepositeAmount.max">{{translations.msgInvalidDepositeAmount}}</mat-error>
                    <mat-error *ngIf="formGroupErrors.P_DepositeAmount.pattern">
                        {{translations.msg2Decimal}}
                    </mat-error>
                </mat-form-field>    
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" 
                [dividerColor]="appService.isNegative(parent.order.P_OutstandingAmount)">
                    <input matInput #outstanding type="number" placeholder="{{translations.txtOutstandingAmount}}"  
                    formControlName="P_OutstandingAmount" (change)="changeOutstanding($event)" 
                    [(ngModel)]="parent.order.P_OutstandingAmount" disabled
                    min="0" max="99999.99"
                    
                    (keypress)="appService.onlyPositiveNumber($event)" 
                    [style.color]="parent.order.P_OutstandingAmount.toString().indexOf('-') > -1 ? 'red' : ''">  
                    <!-- <mat-error *ngIf="formGroupErrors.P_OutstandingAmount.required">
                        {{translations.msgPleaseEnterOA}}
                    </mat-error> -->
                    <mat-error *ngIf="formGroupErrors.P_OutstandingAmount.pattern">
                        {{translations.msg2Decimal}}
                    </mat-error>      
                    <mat-error *ngIf="formGroupErrors.P_OutstandingAmount.min">{{translations.msgInvalidOutstandingAmount}}</mat-error> 
                    <mat-error *ngIf="formGroupErrors.P_OutstandingAmount.max">{{translations.msgInvalidOutstandingAmount}}</mat-error>
                </mat-form-field>   
                
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                    <mat-select placeholder="{{translations.txtPaidTo}}" formControlName="P_PaidTo" 
                    [(ngModel)]="parent.order.P_PaidTo" (selectionChange)="changeColor($event)" class="{{oPaidTo}}">
                      <mat-option value="0"></mat-option>  
                      <mat-option *ngFor="let paidTo of PaidToList" [value]="paidTo.Id" [style.color]="paidTo.Value">{{paidTo.Text}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroupErrors.P_PaidTo.required">
                        {{translations.msgPleaseSelectpaidTo}}
                    </mat-error>
                </mat-form-field>
            </div>

             <div fxLayout="row" fxLayoutAlign="start left">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" >
                    <input matInput #actualpaid type="number" 
                        placeholder="{{translations.lblActualPaid}}" [(ngModel)]="parent.order.P_ActualPaid" 
                            formControlName="P_ActualPaid"  min="0" max="99999.99"  
                                (keypress)="appService.onlyPositiveNumber($event)" (change)="updateOutstanding($event)">  
                    <mat-error *ngIf="formGroupErrors.P_ActualPaid.pattern">
                        {{translations.msg2Decimal}}
                    </mat-error>              
                </mat-form-field>
             </div>
    
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="100">
                    <textarea #remark matInput rows="8" placeholder="{{translations.lblActualPaidRemark + '(' + (1000 - remark.value.length) + ')' }}" [required]="actualpaid.value > 0 && outstanding.value > 0" formControlName="P_ActualPaidRemark" [(ngModel)]="parent.order.P_ActualPaidRemark" maxlength="1000">
                    </textarea>
                    <mat-error *ngIf="formGroupErrors.P_ActualPaidRemark.required">
                        {{translations.msgPleaseEnterRemark}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start left">
              
            </div>
    
        </form>
      
    </div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/payment-detail/payment-detail.component.html